import { Box, styled } from '@mui/material';
import { spaceCadet } from '../utils/colors';

const ExplanationBox = styled(Box)({
  backgroundColor: spaceCadet[800],
  color: spaceCadet[100],
  padding: '8px 12px',
  '& .smallText': {
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 400,
  },
});

export default ExplanationBox;
